export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">联系我们</h2>
        <p className="text-sm md:text-base text-foreground-600 mb-10 max-w-lg mx-auto">
          欢迎漫画作者、版权方、读者朋友与我们取得联系
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-[800px] mx-auto">
          <div className="bg-background-50 rounded-xl p-6 flex flex-col items-center gap-3">
            <span className="w-12 h-12 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
              <i className="ri-mail-line text-xl"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-900">投稿合作</h3>
            <p className="text-xs text-foreground-500">漫画作者与版权合作接洽</p>
            <span className="text-sm text-primary-600 font-medium">contact@xiuxiuwaiwai.com</span>
          </div>

          <div className="bg-background-50 rounded-xl p-6 flex flex-col items-center gap-3">
            <span className="w-12 h-12 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center">
              <i className="ri-question-answer-line text-xl"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-900">读者反馈</h3>
            <p className="text-xs text-foreground-500">意见、建议与问题反馈</p>
            <span className="text-sm text-accent-600 font-medium">feedback@xiuxiuwaiwai.com</span>
          </div>

          <div className="bg-background-50 rounded-xl p-6 flex flex-col items-center gap-3">
            <span className="w-12 h-12 rounded-full bg-secondary-100 text-secondary-600 flex items-center justify-center">
              <i className="ri-group-line text-xl"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-900">商务联系</h3>
            <p className="text-xs text-foreground-500">广告投放与商务合作咨询</p>
            <span className="text-sm text-secondary-600 font-medium">biz@xiuxiuwaiwai.com</span>
          </div>
        </div>
      </div>
    </section>
  );
}